var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSearch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31.614,
    height: 29.639,
    viewBox: "0 0 31.614 29.639",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#e87722;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-114.755 -484.724)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M145.966,493.66a15.467,15.467,0,0,0-3.953-5.192c-2.331-1.941-4.713-4.124-8.768-3.688a8.747,8.747,0,0,0-3.142.922,17.316,17.316,0,0,0-7.146,7.375c-1.725,3.79-.054,6.912,1.941,9.21l-5.019,3.792-5.123,4.4,4,3.883,5.264-5.177L128,505.279a12.3,12.3,0,0,0,2.356,1.531,10.218,10.218,0,0,0,7.855-.242,17.115,17.115,0,0,0,7.3-7.327A6.815,6.815,0,0,0,145.966,493.66Zm-6.761,7.052c-1.147,1.441-2.552,1.665-4.344,1.8a6.738,6.738,0,0,1-6.985-5.882,6.177,6.177,0,0,1,2.8-5.992,7.941,7.941,0,0,1,2.723-1.029c2.58-.412,3.87.357,5.446,2,1.218,1.235,2.173,2.2,2.173,4.529A8.1,8.1,0,0,1,139.2,500.712Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M241.853,524.8c3.626,5.3,2.747,8.571,2.747,8.571C247.951,527.573,241.853,524.8,241.853,524.8Z",
    transform: "translate(-106.334 -33.527)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.2886f6c109f96cb9aff339a1da77a302.svg";
export { ForwardRef as ReactComponent };